import SandhillsImage from '@Components/Shared/Controls/SandhillsImage';

const Link = (props) => {
    return (
        <a href={props.Url} className={props.ClassName} target={props.Target || ''} onClick={props.onClick}>
            {props.childData ?
                <SandhillsImage
                    alt={props.childData.alt ? props.childData.alt : ''}
                    className={props.childData.className ? props.childData.className : ''}
                    src={props.childData.original ? props.childData.original : ''}
                    height={props.childData.height ? props.childData.height : ''}
                    width={props.childData.width ? props.childData.width : ''}
                />
                :
                props.text}
            {props.hiddenText && 
                <span className='visually-hidden'>({props.hiddenText})</span>}
        </a>
    );
};

export default Link;